import React from 'react';

interface IHintIconErrorProps {
	size?: string;
	fill?: string;
	className?: string;
}

export const HintIconError = ({ size = '24', className = '', fill = '#CC3333' }: IHintIconErrorProps) => (
	<svg
		role="img"
		className={className}
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-labelledby="hintIconError">
		<path d="M23 21H1L12 2L23 21ZM11 18H13V16H11V18ZM11 14H13V10H11V14Z" fill={fill} />
	</svg>
);
